import styled, { css } from "styled-components";
import Tooltip from "../Tooltip";

interface ContainerProps {
  isFocused: boolean;
  secondaryColor?: string;
  alwaysShow?: boolean;
  isFilled: boolean;
  width?: string;
  isErrored: boolean;
}

interface TooltipProps {
  isErrored?: boolean;
}

interface width {
  width?: string;
}

export const Container = styled.div<width>`
  background: transparent;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  ${(props) =>
    props.width
      ? css`
          width: ${props.width};
        `
      : css`
          width: 100%;
        `}
`;

export const Content = styled.div<ContainerProps>`
  background: transparent;
  color: #3c4d62;
  height: 3rem;
  align-items: center;
  border: 2px solid #dbdfea;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0.35rem 1rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  /* Enable container queries based on this component's inline size */
  container-type: inline-size;

  & + div {
    margin-top: 4px;
  }

  ${(props) =>
    props.width
      ? css`
          width: ${props.width};
        `
      : css`
          width: 100%;
        `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${(props) => props.theme.primary.light};
      color: ${(props) => props.theme.secondary?.secondary_05};
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: ${(props) => props.theme.primary.light}; ;
    `}

    
  ${(props) =>
    props.isErrored &&
    css`
      border-color: ${color} !important;
    `}

  input {
    outline: 0;
    background: transparent;
    flex: 1;
    border: 0;
    color: #3c4d62;

    /* Improve mobile rendering */
    -webkit-appearance: none;
    -webkit-text-size-adjust: 100%;

    &:disabled {
      color: #a3a3a3;
      cursor: not-allowed;
    }

    &::placeholder {
      color: #a3a3a3;
    }
    & + input {
      margin-top: 8px;
    }
  }

  span {
    margin-right: 8px;
    color: ${(props) => props.theme.fonts.disable_text};
    font-weight: 500;
  }

  /* Left icon container */
  .icon {
    display: inline-flex;
    align-items: center;
  }

  /* Hide left icon on small screens */
  @media (max-width: 600px) {
    .icon {
      display: none;
    }
  }

  svg {
    font-size: 22px;
  }
  button {
    :hover {
      background-color: transparent;
      color: ${(props) => props.theme.primary.light};
      transition: 1s;
    }
  }

  /* When viewport is very narrow, force input text to center vertically */
  @media (max-width: 400px) {
    input {
      height: calc(3rem - 0.7rem);      /* 3rem container - vertical paddings */
      line-height: calc(3rem - 0.7rem);
      padding: 0;
      display: block;
    }
  }

  /* Hide left icon when this Input gets too narrow */
  @container (max-width: 300px) {
    .icon {
      display: none;
    }
  }
`;

const color = '#d9534f';

export const Error = styled.p`
  color: ${color} !important;
  padding: 0.35rem 1rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
`;

export const Label = styled.label<ContainerProps>`
  font-size: 14px;
  padding-bottom: 2.5px;
  width: 100%;
  height: auto;

  ${(props) =>
    props.isFocused || props.isFilled
      ? css`
          visibility: visible;
          color: ${(props) => props.theme.primary.light}; ;
        `
      : css`
          visibility: hidden;
        `}


          ${(props) =>
    props.alwaysShow &&
    css`
      visibility: visible;
      color: ${(props) => props.theme.primary.light}; ;
    `}

    ${(props) =>
    props.isErrored &&
    css`
      color: ${color} !important;
    `}
`;
